import 'jquery';

jQuery(function () {
  $('[data-faqs]').each(function () {
    $(this).on('click', function () {
      const button = $(this).find($('[data-faqs-button]'));
      button.hasClass('down')
        ? button.removeClass('down')
        : button.addClass('down');

      button.hasClass('up') ? button.removeClass('up') : button.addClass('up');

      const answer = $(this).find($('[data-faqs-answer]'));
      answer.hasClass('h-0')
        ? answer
            .removeClass('h-0')
            .removeClass('opacity-0')
            .addClass('duration-300')
        : answer
            .addClass('h-0')
            .addClass('opacity-0')
            .removeClass('duration-300');
    });
  });
});
